
import CardInfo from '../CardInfo'
import ProductSpecific from './ProductSpecific'
import ProductOther from './ProductOther'
import ProductGallery from './ProductGallery'
export default {
  data () {
    return {
      data: [],
      other: [],
      gallery: false,
      jsGallery: {
        imgArr: [],
        index: 0
      }
    }
  },
  components: {
    CardInfo,
    ProductSpecific,
    ProductOther,
    ProductGallery
  },
  watch: {
    $route () {
      this.$q.loading.show({
        backgroundColor: 'white',
        spinnerColor: 'indigo-10'
      })
      this.data = ''
      // location.reload()
      this.timer = setTimeout(() => {
        this.GetData(this.$route.params.name)
        this.$q.loading.hide()
      })
    }
  },
  mounted () {
    this.GetData(this.$route.params.name)
  },
  methods: {
    GetData (name) {
      var data = this.FindDataFromDB(name)
      this.data = data
      console.log(this.data)
      // window.scrollTo(0, 0)
    },
    FindDataFromDB (title) {
      var data = {
        items: [
          {
            id: 1,
            infoCard: 'Advance Thickboard’s excellent physical and surface properties makes it most suitable for interior applications that are not exposed to damp conditions',
            title: 'Advance Thickboard',
            img: 'product/thickboard/product-thickboard',
            subTitle: 'Suitable Use',
            infoMain: 'Thickboard is recommended for use in the furniture and cabinet making industries, but its true potential is limited only by your imagination.',
            info: 'Current applications of Thickboard include furniture, flooring, walls, mouldings, shelving, cabinets, to partitions, frames and stereo speakers. At Advance Fiber, we believe that our products will be able to fulfill your needs of the highest quality.',
            specification: {
              text: 'We can cut boards to customer’s specifications and can provide boards as large as 8 feet wide by 24 feet long.',
              info: {
                'Standard Size': '1220 mm x 2440 mm',
                Thickness: '> 6 – 25 mm',
                'Formaldehyde Content': 'Class E1 ≤ 8.0 mg/100g,<br /> Class E2 > 8.0 ≤ 30 mg/100g',
                'Raw Material': 'Rubber wood/ Eucalyptus <br /> (FSC certification optional)'
              }
            },
            imgArr: [
              {
                id: 1,
                name: 'Cabinets',
                img: 'thickboard/info-01',
                position: '50% 50%',
                color: 'black'
              },
              {
                id: 2,
                name: 'Flooring',
                img: 'thickboard/info-02',
                position: '50% 100%',
                color: 'white'
              },
              {
                id: 3,
                name: 'Furniture',
                img: 'thickboard/info-03',
                position: '50% 50%',
                color: 'white'
              },
              {
                id: 4,
                name: 'Walls',
                img: 'thickboard/info-04',
                position: '50% 50%',
                color: 'white'
              }
            ]
          },
          {
            id: 2,
            infoCard: "Advance Thinboard's excellent physical and hard smooth surface properties makes it most suitable for applications that require thin panels and are not exposed to damp conditions",
            title: 'Advance Thinboard',
            img: 'product/thinboard/product-thinboard',
            subTitle: 'Suitable Use',
            infoMain: 'Thin board panels are recommended for interior applications such as cupboard backs; bottom of drawers; wall panels and door skins.',
            info: 'With the most advanced technology in our production line, we can offer our customers panels with thickness ranging from 1.5mm to 25mm. ',
            specification: {
              text: 'We can cut boards to customer’s specifications and can provide boards as large as 8 feet wide by 24 feet long.',
              info: {
                'Standard Size': '1220 mm x 2440 mm',
                Thickness: '1.5 – 6 mm',
                'Formaldehyde Content': 'Class E1 ≤ 8.0 mg/100g,<br /> Class E2 > 8.0 ≤ 30 mg/100g',
                'Raw Material': 'Rubber wood/ Eucalyptus <br /> (FSC certification optional)'
              }
            },
            imgArr: [
              {
                id: 1,
                name: 'Cupboard backs',
                img: 'thinboard/info-01',
                color: 'black'
              },
              {
                id: 2,
                name: 'Bottoms of drawers',
                img: 'thinboard/info-02',
                position: '50% 100%',
                color: 'white'
              },
              {
                id: 3,
                name: 'Door skin',
                img: 'thinboard/info-03',
                position: '10% 50%',
                color: 'white'
              },
              {
                id: 4,
                name: 'Furniture',
                img: 'thinboard/info-04',
                position: '50% 100%',
                color: 'black'
              },
            ]
          },
          {
            id: 3,
            infoCard: 'In 2008, Advance Fiber launched a direct printing line. We use the latest, cutting edge technology to print designs directly onto the MDF surface, eliminating the need for paper and glue while offering an attractive designs.',
            title: 'Advance Colourboard',
            img: 'product/colourboard/product-colourboard',
            subTitle: 'Printable Patterns',
            infoMain: 'Advance Colourboard is our melamine laminated MDF product line, available in 3 standard woodgrain patterns Beech, Oak and Cherry.',
            info: 'We are offering laminated products that are widely used for furniture and laminated flooring. ',
            specification: {
              text: 'Direct printing offers the flexibility to tailor the appearance of MDF to accommodate the design requirements of our customers. Once we are given the pattern and colour sample, we are able to dial in our line to reproduce with ease and accuracy. After printing, we apply a clear coating to improve durability and enhance the attractiveness of the material.',
              info: {
                'Standard Size': '1220 mm x 2440 mm',
                Thickness: '2.5 – 25 mm',
                'Formaldehyde Content': 'Class E1 ≤ 8.0 mg/100g,<br /> Class E2 > 8.0 ≤ 30 mg/100g',
                'Raw Material': 'Rubber wood/ Eucalyptus <br /> (FSC certification optional)'
              }
            },
            imgArr: [
              {
                id: 1,
                name: 'Standard Beech',
                img: 'colourboard/info-01',
                color: 'black'
              },
              {
                id: 2,
                name: 'Standard Oak',
                img: 'colourboard/info-02',
                color: 'black'
              },
              {
                id: 3,
                name: 'Standard Cherry',
                img: 'colourboard/info-03',
                color: 'black'
              },
              {
                id: 4,
                name: 'Possible Pattern',
                img: 'colourboard/info-04'
              }
            ]
          },
          {
            id: 4,
            infoCard: 'Advance Fiber also produces and distributes High Moisture Resistance Boards (HMR), for applications where product stability and durability is required. Both V 70 and V 313 are bonded with a special moisture resistant binder and coloured green for ease of identification.',
            title: 'Advance HMR',
            img: 'product/hmr/product-hmr',
            subTitle: 'Suitable Use',
            infoMain: 'The key characteristics of HMR are its homogeneous properties, smooth texture and resistance to moisture.',
            info: 'Our moisture resistant board can withstand moisture in high humidity conditions such as laundry rooms, kitchens and bathrooms. However, HMR products are not recommended for outdoor use or in an application where they are exposed to water regularly. ',
            specification: {
              text: 'We can cut boards to customer’s specifications and can provide boards as large as 8 feet wide by 24 feet long.',
              info: {
                'Standard Size': '1220 mm x 2440 mm',
                Thickness: '12 – 25 mm',
                'Thickness Swelling': '7 – 8%',
                'Formaldehyde Content': 'Class E1 ≤ 8.0 mg/100g,<br /> Class E2 > 8.0 ≤ 30 mg/100g',
                'Standards': 'V70, V313'
              }
            },
            imgArr: [
              {
                id: 1,
                name: 'Bathroom',
                img: 'hmr/info-01',
                color: 'black'
              },
              {
                id: 2,
                name: 'Laundry Room',
                img: 'hmr/info-02',
                color: 'white',
                position: '0% 50%'
              },
              {
                id: 3,
                name: 'Bathroom',
                img: 'hmr/info-03',
                color: this.$q.screen.width > 1250 ? 'white' : 'black'
              },
              {
                id: 4,
                name: 'Kitchen',
                img: 'hmr/info-04',
                color: 'black'
              }
            ]
          },
          {
            id: 5,
            infoCard: 'Advance SHDF is a specially formulated Super High Density Fibre composite panel that is suitable for applications where high durability and reliability is required.',
            title: 'Advance SHDF',
            img: 'product/shdf/product-shdf',
            subTitle: 'Suitable Use',
            infoMain: 'SHDF’s high density and surface hardness give the product its superior quality, which makes the panels more suitable for high durability applications.',
            info: 'SHDF is commonly used as an alternative shuttering board for concrete formwork construction in places such as airports, public facilities, schools and shopping centers.  Advance SHDF retains the ability to be easily cut, machined and surface covered.',
            specification: {
              text: 'We can cut boards to customer’s specifications and can provide boards as large as 8 feet wide by 24 feet long.',
              info: {
                'Standard Size': '1220 mm x 2440 mm',
                Thickness: '12 - 18 mm',
                'Formaldehyde Content': 'Class E1 ≤ 8.0 mg/100g,<br /> Class E2 > 8.0 ≤ 30 mg/100g',
                'Raw Material': 'Rubber wood/ Eucalyptus <br /> (FSC certification optional)'
              }
            },
            imgArr: [
              {
                id: 1,
                name: 'Shopping Centres',
                img: 'shdf/info-01',
                color: 'white'
              },
              {
                id: 2,
                name: 'School',
                img: 'shdf/info-02',
                color: 'black'
              },
              {
                id: 3,
                name: 'Airport',
                img: 'shdf/info-03',
                color: 'white',
                position: '0 60%'
              },
              {
                id: 4,
                name: 'Shopping Centres',
                img: 'shdf/info-04',
                color: 'white'
              }
            ]
          }
        ]
      }
      var result = []
      this.other = []
      data.items.forEach((value) => {
        if (value.title === title) {
          return result = value
        }
        else {
          return this.other.push(value)
        }
      })
      return result
    },
    OpenGallery (arr, index) {
      this.jsGallery.imgArr = arr
      this.jsGallery.index = index
      this.gallery = true
    },
    CloseGallery (value) {
      this.gallery = value
    }
  }
}
